import { useRef } from 'react';

import { RecommendationType } from '@xing-com/crate-common-graphql-types';
import {
  type NWTEvent,
  useTracking as useTrackingNWT,
} from '@xing-com/crate-communication-tracking';

export type TrackParams = {
  itemUrn?: string;
  trackingToken?: string;
  status: 'TakenJob' | 'AvailableJob';
  cardType: 'job_reco';
  position: number;
};

type UseTrackingReturn = {
  trackInView: (params: TrackParams) => void;
  trackClickOnFilter: () => void;
  trackFilterSelection: (filterSelected: string) => void;
  trackClickOnShuffleAll: () => void;
};

// TODO: change this
const page = 'jobs/index';

export function useTracking(): UseTrackingReturn {
  const { track: trackNwt } = useTrackingNWT<NWTEvent>();
  const trackedInView = useRef<string[]>([]);

  // card entered viewport
  const trackInView = ({
    itemUrn,
    trackingToken,
    status,
    position,
  }: TrackParams): void => {
    if (itemUrn && !trackedInView.current.includes(itemUrn)) {
      trackNwt({
        type: 'nwt',
        event: 'entered_viewport',
        eventSchema: 'basic',
        sentBy: 'jobs',
        page,
        element: 'job_reco_card',
        elementDetail: 'dream_job_reco',
        context: `dream_job_status_${status === 'AvailableJob' ? 'available' : 'taken'}`,
        itemUrn,
        trackingToken,
        position,
      });
      trackedInView.current.push(itemUrn);
    }
  };

  const trackClickOnFilter = (): void => {
    trackNwt({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'basic',
      sentBy: 'jobs',
      page,
      element: 'job_reco_filter_open',
    });
  };

  const trackFilterSelection = (filterSelected: string): void => {
    const filter =
      filterSelected === RecommendationType.Available
        ? 'more_available'
        : filterSelected === RecommendationType.Taken
          ? 'more_occupied'
          : 'available_occupied';

    trackNwt({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'basic',
      sentBy: 'jobs',
      page,
      element: `job_reco_filter_${filter}_apply`,
    });
  };

  const trackClickOnShuffleAll = (): void => {
    trackNwt({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'basic',
      sentBy: 'jobs',
      page,
      element: 'shuffle_all',
    });
  };

  return {
    trackInView,
    trackClickOnFilter,
    trackFilterSelection,
    trackClickOnShuffleAll,
  };
}
